import { render } from "./waiting.vue?vue&type=template&id=d10c90fc&scoped=true"
import script from "./waiting.vue?vue&type=script&lang=js"
export * from "./waiting.vue?vue&type=script&lang=js"

import "./waiting.vue?vue&type=style&index=0&id=d10c90fc&scoped=true&lang=scss"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d10c90fc"]])

export default __exports__